module.exports = __webpack_public_path__ + "img/bell.e8b4c276.svg";